/**
 * Enum representing the display styles for the calendar chooser.
 *
 * @enum CalendarChooserDisplayStyle
 * @platform iOS
 */
export var CalendarChooserDisplayStyle;
(function (CalendarChooserDisplayStyle) {
    /**
     * Display all calendars available for selection.
     */
    CalendarChooserDisplayStyle[CalendarChooserDisplayStyle["ALL_CALENDARS"] = 0] = "ALL_CALENDARS";
    /**
     * Display only writable calendars available for selection.
     */
    CalendarChooserDisplayStyle[CalendarChooserDisplayStyle["WRITABLE_CALENDARS_ONLY"] = 1] = "WRITABLE_CALENDARS_ONLY";
})(CalendarChooserDisplayStyle || (CalendarChooserDisplayStyle = {}));
//# sourceMappingURL=calendar-chooser-display-style.js.map